/* START_MODULE_CONTRACT
 * PURPOSE: Frontend UI module: ConcurrentRolesSelect.
 * SCOPE: React component or page.
 * DEPENDS: M-FE-API, M-FE-AUTH
 * LINKS: M-FE-ROLES
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * ConcurrentRolesSelect - Frontend UI module: ConcurrentRolesSelect.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-02 - GRACE coverage: контракт компонента и парный END_METHOD.
 * END_CHANGE_SUMMARY
 */

import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

/* START_METHOD_ConcurrentRolesSelect */
/* START_CONTRACT: ConcurrentRolesSelect
 * PURPOSE: Мультивыбор совместимых (параллельных) ролей, исключая текущую роль.
 * INPUTS: { label: string, roles: ProjectRole[], excludeRoleId: number, value: ProjectRole[], onChange: (v)=>void, disabled: boolean }.
 * OUTPUTS: { JSX.Element - мультиселект }.
 * SIDE_EFFECTS: нет (делегирует onChange).
 * LINKS: M-FE-ROLES
 * END_CONTRACT: ConcurrentRolesSelect
 */
export default function ConcurrentRolesSelect({
  label,
  roles,
  excludeRoleId,
  value,
  onChange,
  disabled,
}) {
  const options = roles.filter((role) => role.id !== excludeRoleId);

  return (
    <Autocomplete
      multiple
      options={options}
      value={value}
      onChange={(_, newValue) => onChange(newValue)}
      getOptionLabel={(option) => `${option.name} (${option.shortName})`}
      isOptionEqualToValue={(option, selected) => option.id === selected.id}
      disabled={disabled || options.length === 0}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          margin="normal"
          size="small"
          placeholder={options.length === 0 ? 'Сначала создайте другие роли' : 'Выберите роли'}
        />
      )}
    />
  );
}
/* END_METHOD_ConcurrentRolesSelect */
